import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import DistanceMeasurement_001 from './img/DistanceMeasurement_001.jpg'
import DistanceMeasurement_002 from './img/DistanceMeasurement_002.jpg'

export default class DistanceMeasurement extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">使用距离量测功能</div>
        <div className="main-window-content">1、点击距离量测</div>
        <div className="main-window-content">2、在球上点选，形成线段，距离数值实时展示</div>
        <img src={DistanceMeasurement_001} className="main-window-img"></img>
        <img src={DistanceMeasurement_002} className="main-window-img"></img>
      </div>
    )
  }
}
